const INVALID_CHARACTERS_REGEX = /[^\d-\.,]|(?:,|\.)(?!\d{1,2}[^\d\.,%]*%?$)/g;
const REPLACE_COMMA_REGEX = /,(?=\d{1,2})/g;

function unformat(value: string, min?: number): number | undefined {
    value = value.replace(INVALID_CHARACTERS_REGEX, '').replace(REPLACE_COMMA_REGEX, '.');
    
    const perc = value ? Number(value) / 100 : undefined;
    return perc ? Math.max(min ?? perc, perc) : perc;
}

export const PercentUtils = {
    unformat
}

export default PercentUtils;